import React from 'react';
import NerdleMap from './js/NerdleMap'
import './App.css';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 800,
      height: 600
    }
  }


  render() {
    const styles = {
      width: "100%",
      height: "100%"
    }
    return (
      <div className="App" style={styles}>
        <NerdleMap width={this.state.width} height={this.state.height} />
      </div>
    );
  }
}
export default App;
